import React from 'react';
import TiptapEditor from './TiptapEditor';

const RichTextEditor = React.forwardRef(({ content, onSave, onCancel }, ref) => {
  return (
    <TiptapEditor ref={ref} content={content} onSave={onSave} onCancel={onCancel} />
  );
});

RichTextEditor.displayName = 'RichTextEditor';

export default RichTextEditor;


